<div mat-dialog-title>
    <div style="padding-top: 3px;">
        Confirm Submit
    </div>
</div>

<mat-dialog-content>
    <div style="padding-top: 10px;padding-bottom: 10px;"> 
        This e-Form will not be editable after it has been submitted.
    </div>
    <div style="padding-top: 10px;padding-bottom: 10px;" *ngIf="!showFeeNote"> 
        If you are sure you do not need to make any more changes select Submit. Otherwise, select Cancel.
    </div>
    <div style="padding-top: 10px;padding-bottom: 10px;" *ngIf="showFeeNote && !showSubmitAndPayNow"> 
        If you are sure you do not need to make any more changes, select Submit. Otherwise, select Cancel.
    </div>
    <div style="padding-top: 10px;padding-bottom: 10px;" *ngIf="showFeeNote && showSubmitAndPayNow"> 
        If you are sure you do not need to make any more changes, select one of the Submit buttons. Otherwise, select Cancel.
    </div>
    <div style="padding-top: 10px;padding-bottom: 10px; color: #b71c1c;" *ngIf="showFeeNote"> 
        {{noteMessage | translate}}
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-left">

    </div>
    <div class="flex-footer-right">
        <tyl-button id="submitAndPayButton" image="save.png" *ngIf="showSubmitAndPayNow"
            label="Submit and Pay Now" (clickEvent)="submitAndPayClick()"></tyl-button>
        <tyl-button id="submitButton" image="save.png" 
            label="Submit" (clickEvent)="submitClick()"></tyl-button>
        <tyl-button id="cancelButton" image="cancel.png" 
            label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>

</mat-dialog-actions>